import React from 'react'

const Customer_invoice_item_ledger_modal = (props) => {
  return (
    <>
        {props.show ? (
        <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative  my-6 mx-auto md:w-3/4 lg:w-3/4">
                {/*content*/}
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/*header*/}
                <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                    <h3 className="text-3xl uppercase font-semibold flex-1">
                        پسوڵەی فرۆشراو
                    </h3>
                    <button
                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-80 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => {
                        props.setshow(false);
                    }}
                    >
                    <span className="bg-transparent text-black h-6 w-6 text-2xl block outline-none focus:outline-none">
                        X
                    </span>
                    </button>
                </div>
                {/*body*/}
                <div className="relative h-[75vh] overflow-y-auto p-6 flex-auto">
                    <div className="flex flex-wrap w-full">
                    <table className="min-w-full leading-normal">
                        <thead>
                        <tr>
                            <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                            ناوی کاڵا
                            </th>
                            <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                            باڕکۆد
                            </th>
                            <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                            جۆر
                            </th>
                            <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                            بڕی فرۆشراو
                            </th>
                            <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                            نرخی کاڵا
                            </th>
                            <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                            نرخی فرۆشراو
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {props?.invoice_detail?.items?.map((lis, index) => (
                            lis.item_qty>0?
                            <tr key={index} className={`${lis.item_type=="service"?'bg-gray-50':'bg-white'}`}>
                            <td className="px-5 py-5 border-b border-gray-200  text-sm">
                                <p className="text-gray-900 whitespace-no-wrap">
                                {lis.item_name}
                                </p>
                            </td>
                            <td className="px-5 py-5 border-b border-gray-200  text-sm">
                                <p className="text-gray-900 whitespace-no-wrap">
                                {lis.item_barcode}
                                </p>
                            </td>
                            <td className="px-5 py-5 border-b border-gray-200  text-sm">
                                <p className="text-gray-900 whitespace-no-wrap">
                                {lis.item_type=="service"?"خزمەتگوزاری":"کاڵا"}
                                </p>
                            </td>
                            <td className="px-5 py-5 border-b border-gray-200  text-sm">
                                <p className="text-gray-900 whitespace-no-wrap">
                                {lis.item_qty}
                                </p>
                            </td>
                            <td className="px-5 py-5 border-b border-gray-200  text-sm">
                                <p className="text-gray-900 whitespace-no-wrap">
                                {lis.item_price}
                                </p>
                            </td>
                            <td className="px-5 py-5 border-b border-gray-200  text-sm">
                                <p className="text-gray-900 whitespace-no-wrap">
                                {lis.item_sell_price}
                                </p>
                            </td>
                            </tr>:null
                        ))}
                        </tbody>
                    </table>
                    </div>
                </div>
                {/*footer*/}
                <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                    <button
                    className="bg-slate-600 text-white active:bg-slate-800 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => {
                        props.setshow(false);
                    }}
                    >
                    داخستن
                    </button>
                </div>
                </div>
            </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
        ) : null}
    </>
  )
}

export default Customer_invoice_item_ledger_modal